import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'
import * as firebase from 'firebase';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
@Injectable()
export class MessagingService {

//   currentMessage = new BehaviorSubject(null);
  messageResponse: any;
  messaging = firebase.messaging();
  currentMessage = new BehaviorSubject(null);

  constructor(
    private http: Http, private router: Router,
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    );
  }

  /**
   * update token in firebase database
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1)).subscribe(
      () => {
        const data = {};
        data[userId] = token;
        this.angularFireDB.object('fcmTokens/').update(data);
      });
  }

  /**
   * request permission for notification from firebase cloud messaging
   * @param userId userId
   */
  requestPermission() {
    console.log('inside request permission');
    return this.angularFireMessaging.requestToken;
}


    // Notification.requestPermission().then(function(result) {
    //   if (result === 'denied') {
    //     console.log('Permission wasn\'t granted. Allow a retry.');
    //     return;
    //   }
    //   if (result === 'default') {
    //     console.log('The permission request was dismissed.');
    //     return;
    //   }
    //   if (result === 'granted') {
    //     console.log('Permission granted.');
    //     return this.messaging.getToken();
    //   }
    // })
  // }

  // requestPermission() {
  //   this.messaging.requestPermission()
  //   .then(() => {
  //     console.log('Notification permission granted.');
  //     return this.messaging.getToken();
  //   })
  //   .then(token => {
  //     console.log('FCM Token', token);
  //     this.updateToken(token)
  //   })
  //   .catch((err) => {
  //     console.log('Unable to get permission to notify.', err);
  //   });
  // }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    // this.angularFireMessaging.messages.subscribe(
    //   (payload) => {
    //     console.log('new message received. ', payload);
    //     this.currentMessage.next(payload);
    //   });
    return this.angularFireMessaging.messages;
  }

  // receiveMessage() {
  //   this.angularFireMessaging.messages.subscribe(
  //       data => {
  //         this.messageResponse = (data);
  //         console.log('messages ++++', this.messageResponse.data.message);
  //         // console.log('messages ++++', this.currentMessage.value(this.messageResponse.data.message));
  //         console.log('messages ++', this.currentMessage.next(this.messageResponse.data.message));
  //     });
  // }

  getMessages() {
      const FCM_token = localStorage.getItem('FCMtoken');
      console.log('received token', FCM_token);
      const data = {
        'token': FCM_token
      };
    console.log('data', data);
    if (data === null) {
      this.requestPermission();
    } else {
      const body = JSON.stringify(data);
      console.log(body);
      return this.http.post(environment.baseUrl + '/notification/registration', body,
      GlobalService.getHeaders()).map((response: Response) => {
        // return this.http.post("http://localhost:4200/proxy" + '/notification/registration', body,
      // GlobalService.getHeaders()).map((response: Response) => {
        console.log('yes');
        console.log(response.status);
        console.log('hhhhh' + response);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
    });
    }
  }

  public getAllAlerts(customerID: any) {
    console.log('inside services');
    const custrID = customerID;
    console.log('custrID', custrID);
    return this.http.get(environment.baseUrl + '/notification/filter/' + custrID + '/' + 0  + '/' + 7, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
}
